import { IChannel } from '@/models/channel.model';

export const getChannelsOptions = (channels?: IChannel[] | null) =>
  (channels ?? []).map((channel) => ({
    value: channel.id,
    label: channel.name ?? channel.slug,
  }));
